import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Typography from '@material-ui/core/Typography'
import React, { useCallback, useState } from 'react'
import {
    BASE_KEY_MODIFICATION_CONTEXT,
    BASE_KEY_MODIFICATION_WARNING,
    KEY_MODIFICATION_WARNING_DISMISSED_KEY,
    PT_KEY_MODIFICATION_WARNING,
} from '../../constants/keyModification'
import { useKeyModificationDialogStore } from './KeyModificationDialogStore'
import { useKeyModificationWarningDialogStyles } from './useKeyModificationWarningDialogStyles'
import { WorkspaceConfirmationDialog } from '../WorkspaceConfirmationDialog'

export const KeyModificationWarningDialog = () => {
    const classes = useKeyModificationWarningDialogStyles()
    const [dontShowAgain, setDontShowAgain] = useState(false)

    const {
        isOpen,
        isPTKey,
        originalKey,
        modifiedKey,
        onProceed,
        onCancel,
        closeDialog,
    } = useKeyModificationDialogStore((state) => ({
        isOpen: state.isOpen,
        isPTKey: state.isPTKey,
        originalKey: state.originalKey,
        modifiedKey: state.modifiedKey,
        onProceed: state.onProceed,
        onCancel: state.onCancel,
        closeDialog: state.closeDialog,
    }))

    const handleDialogClose = useCallback(() => {
        setDontShowAgain(false)
        onCancel?.()
        closeDialog()
    }, [onCancel, closeDialog])

    const handleProceed = useCallback(async () => {
        // If user checked "Don't show again", store it in sessionStorage for the entire session
        if (dontShowAgain) {
            sessionStorage.setItem(KEY_MODIFICATION_WARNING_DISMISSED_KEY, 'true')
        }

        setDontShowAgain(false)
        onProceed?.()
        closeDialog()
    }, [dontShowAgain, onProceed, closeDialog])

    if (!isOpen) return null

    // For PT keys, show blocking warning with no proceed option
    if (isPTKey) {
        return (
            <WorkspaceConfirmationDialog
                openDialog={isOpen}
                handleDialogClose={handleDialogClose}
                dialogActionCallback={handleDialogClose}
                contentNode={
                    <Typography
                        className={classes.conflictMessage}
                        id="pt-key-warning-description"
                    >
                        {PT_KEY_MODIFICATION_WARNING}
                    </Typography>
                }
                size="small"
                dialogHeading="Cannot Modify Key"
                confirmText="OK"
                cancelText=""
                confirmMessage=""
                ariaDescribedBy="pt-key-warning-description"
            />
        )
    }

    // For base content keys, show warning with Cancel/Proceed options
    return (
        <WorkspaceConfirmationDialog
            openDialog={isOpen}
            handleDialogClose={handleDialogClose}
            dialogActionCallback={handleProceed}
            contentNode={
                <>
                    <Typography
                        className={classes.conflictMessage}
                        id="key-modification-warning-description"
                    >
                        {BASE_KEY_MODIFICATION_WARNING}
                    </Typography>
                    <Typography className={classes.contextMessage}>
                        {BASE_KEY_MODIFICATION_CONTEXT}
                    </Typography>
                </>
            }
            footerContent={
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={dontShowAgain}
                            onChange={(e) => setDontShowAgain(e.target.checked)}
                            color="primary"
                        />
                    }
                    label="Don't show this warning again"
                />
            }
            size="small"
            dialogHeading="Warning"
            confirmText="Proceed"
            confirmMessage="Do you want to proceed?"
            ariaDescribedBy="key-modification-warning-description"
        />
    )
}
